<div class="page-root">
  @if (mode == 'mobile') {
    <div class="page-one-column-body">
      <div class="root-column">
        <app-logo/>
        <router-outlet/>
      </div>
    </div>
  } @else {
    <div class="page-two-column-body">
      <div class="root-row">
        <div class="flex">
          <div class="column">
            <app-logo/>
            <app-selected-appointment [mobile]="false"/>
          </div>
        </div>

        <mat-divider class="primary" vertical/>

        <div class="flex">
          @if (!memoryService.patientId) {
            <app-booking-login [mobile]="false"/>
          } @else {
            <app-confirm [mobile]="false"/>
          }
        </div>
      </div>
    </div>
  }
</div>
